// const MAX_WIDTH = 2000;
// const MAX_HEIGHT = 2000;

import { SelectedFile } from 'types/productTypes';

export const resizeImage = (
  file: File,
  imageQuality: number
): Promise<File> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target?.result as string;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const width = img.width;
        const height = img.height;

        //? Maintain aspect ratio while resizing
        //   if (width > height) {
        //     if (width > MAX_WIDTH) {
        //       height = Math.floor((height * MAX_WIDTH) / width);
        //       width = MAX_WIDTH;
        //     }
        //   } else {
        //     if (height > MAX_HEIGHT) {
        //       width = Math.floor((width * MAX_HEIGHT) / height);
        //       height = MAX_HEIGHT;
        //     }
        //   }

        // Draw the resized image on the canvas
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(img, 0, 0, width, height);

          // Convert the canvas to a blob (file) with better compression
          canvas.toBlob(
            (blob) => {
              if (blob) {
                const resizedFile = new File([blob], file.name, {
                  type: file.type,
                });
                resolve(resizedFile);
              } else {
                reject(new Error('Failed to resize image'));
              }
            },
            file.type,
            imageQuality // Lower compression quality (adjust this between 0 and 1 as needed)
          );
        } else {
          reject(new Error('Canvas context not available'));
        }
      };
    };

    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

export const convertPngToJpg = (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target?.result as string;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        if (!ctx) {
          reject(new Error('Canvas context not available'));
          return;
        }

        // Set canvas dimensions to match the image dimensions
        canvas.width = img.width;
        canvas.height = img.height;

        // Fill the canvas with a white background before drawing the image
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Draw the image onto the canvas
        ctx.drawImage(img, 0, 0, img.width, img.height);

        // Convert the canvas to a JPEG blob
        canvas.toBlob(
          (blob) => {
            if (blob) {
              // Create a new file from the JPEG blob
              const jpgFile = new File(
                [blob],
                file.name.replace(/\.[^/.]+$/, '.jpg'),
                {
                  type: 'image/jpeg',
                }
              );
              resolve(jpgFile);
            } else {
              reject(new Error('Conversion to JPEG failed'));
            }
          },
          'image/jpeg',
          0.8 // Adjust compression level (0.8 gives good quality while reducing size)
        );
      };
    };

    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

export const formatBytes = (bytes: any, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const convertToFileType = async (
  selectedFile: SelectedFile
): Promise<File> => {
  //? If the preview is a base64 data URL
  if (selectedFile.preview.startsWith('data:')) {
    const blob = await fetch(selectedFile.preview).then((res) => res.blob());
    return new File([blob], selectedFile.name, {
      type: selectedFile.type,
      lastModified: Date.now(),
    });
  }

  //? If the preview is a blob URL
  if (selectedFile.preview.startsWith('blob:')) {
    const blob = await fetch(selectedFile.preview).then((res) => res.blob());
    return new File([blob], selectedFile.name, {
      type: selectedFile.type,
      lastModified: Date.now(),
    });
  }

  throw new Error('Unsupported file format');
};

export const getImageNameFromUrl = (url: string) => {
  const urlParts = url.split('/');
  return urlParts[urlParts.length - 1];
};
